export default __webpack_public_path__ + "static/media/TERMINAL_ICON_05.ee11dd96.svg";